<template>
  <div class="customer-list clearfix">
    <Search @getHeight="getHeight"
            @add="AddRegistrations"
            @saveSet="saveSet"
            width="350px"
            ref="Search"
            :isquery="true"
            :functionBtn="true"
            :delPara="delPara"
            :showSort="false"
            :tableConfig="tableConfig"
            :tableName="tableName"
            searchName="getCustomerList">
      <template v-slot:left>
        <!-- <el-col :lg="12"
                :md="12"
                :sm="12"
                :xs="12">
          <el-form-item label="人员状态">
            <el-select v-model="searchForm.state"
                       clearable
                       style="width: 100%"
                       placeholder="请选择状态">
              <el-option v-for="item in statusList"
                         :key="item.Value"
                         :label="item.value"
                         :value="item.num"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :lg="24"
                :md="24"
                :sm="24"
                :xs="24">
          <el-form-item label="关键字"
                        prop="keyWord">
            <el-input @keyup.enter.native="$refs.Search.handleSearch"
                      v-model="searchForm.keyWord"
                      clearable
                      placeholder="请输入关键字查询"></el-input>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:center>
        <!-- <el-button size="mini"
                   icon="el-icon-upload"
                   type="success"
                   plain
                   v-if="verifyPermission('Update')"
                   @click="importExport">批录人员</el-button> -->
        <el-button size="mini"
                   icon="el-icon-edit"
                   type="success"
                   plain
                   v-if="dataFlag && verifyPermission('Update')"
                   @click="batchState">批改状态</el-button>
      </template>
      <template v-slot:advancedQuery>
        <el-col :lg="7"
                :md="10"
                :sm="12"
                :xs="24">
          <el-form-item label="注册时间">
            <el-col :span="11">
              <el-date-picker v-model="searchForm.createStatrDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择开始日期"
                              style="width: 100%">
              </el-date-picker>
            </el-col>
            <el-col :span="1">~</el-col>

            <el-col :span="11">
              <el-date-picker v-model="searchForm.createEndDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择结束日期"
                              style="width: 100%">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :lg="4"
                :md="8"
                :sm="12"
                :xs="24">
          <el-form-item label-width="100px"
                        label="是否有身份证"
                        prop="isCooperation">
            <el-select v-model="searchForm.isHaveIdentityCard"
                       clearable
                       placeholder="请选择"
                       @clear="clear">
              <el-option label="是"
                         :value="true"></el-option>
              <el-option label="否"
                         :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4"
                :md="8"
                :sm="12"
                :xs="24">
          <el-form-item label-width="100px"
                        label="是否退役军人"
                        prop="isCooperation">
            <el-select v-model="searchForm.isVeteran"
                       clearable
                       placeholder="请选择"
                       @clear="clear">
              <el-option label="是"
                         :value="true"></el-option>
              <el-option label="否"
                         :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="7"
                :md="10"
                :sm="12"
                :xs="24">
          <el-form-item label="入职时间">
            <el-col :span="11">
              <el-date-picker v-model="searchForm.entryStartDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              placeholder="选择开始日期"
                              style="width: 100%">
              </el-date-picker>
            </el-col>
            <el-col :span="1">~</el-col>

            <el-col :span="11">
              <el-date-picker v-model="searchForm.entryEndDate"
                              value-format="yyyy-MM-dd"
                              type="date"
                              style="width: 100%"
                              placeholder="选择结束日期">
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :lg="4"
                :md="8"
                :sm="12"
                :xs="24">
          <el-form-item label="在职企业">
            <el-select filterable
                       v-model="searchForm.entryFactoryId"
                       clearable
                       style="width: 100%"
                       @change="PositionList2"
                       placeholder="请选择在职企业">
              <el-option v-for="item in companyList"
                         :key="item.id"
                         :label="item.customerName"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4"
                :md="8"
                :sm="12"
                :xs="24">
          <el-form-item label="职位">
            <el-select filterable
                       v-model="searchForm.entryPositionId"
                       clearable
                       style="width: 100%"
                       placeholder="请先选择企业">
              <el-option v-for="item in positionList"
                         :key="item.id"
                         :label="item.positionName"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
    </Search>
    <div class="customer-table-list fr page">
      <MyTable @sortChange="sortChange"
               @selectionChange="selectionChange"
               @selectChange="selectChange"
               :rowClickFlag="true"
               @dbclick="dbclick"
               tableType="selection"
               :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight"
               :indexFlag="true"
               tableEmptyText="暂无数据，点击新增"
               @EmptyBtn="AddRegistrations">
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:userType="slotData">
          <el-tag size="small"
                  type="info"
                  v-if="slotData.scope.row.userType == 0">普通用户
          </el-tag>
          <el-tag size="small"
                  v-if="slotData.scope.row.userType == 1">推荐人
          </el-tag>
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.userType == 2">经纪人
          </el-tag>
        </template>
        <template v-slot:isOnjob="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.isOnjob == true">是
          </el-tag>
          <el-tag size="small"
                  type="danger"
                  v-if="slotData.scope.row.isOnjob == false">否
          </el-tag>
        </template>
        <template v-slot:state="slotData">
          <div @click="oneClick(slotData.scope.row)"
               class="tableClick">
            {{ slotData.scope.row.state | state }}
          </div>
        </template>

        <template v-slot:isVeteran="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.isVeteran == true">是
          </el-tag>
          <el-tag size="small"
                  type="danger"
                  v-if="
              slotData.scope.row.isVeteran == false ||
              slotData.scope.row.isVeteran == null
            ">否
          </el-tag>
        </template>
        <template v-slot:isStudent="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.isStudent == true">是
          </el-tag>
          <el-tag size="small"
                  type="danger"
                  v-if="
              slotData.scope.row.isStudent == false ||
              slotData.scope.row.isStudent == null
            ">否
          </el-tag>
        </template>
        <template v-slot:isStore="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.isStore == true">是
          </el-tag>
          <el-tag size="small"
                  type="danger"
                  v-if="
              slotData.scope.row.isStore == false ||
              slotData.scope.row.isStore == null
            ">否
          </el-tag>
        </template>
        <template v-slot:isInsder="slotData">
          <el-tag size="small"
                  type="success"
                  v-if="slotData.scope.row.isInsder == true">是
          </el-tag>
          <el-tag size="small"
                  type="danger"
                  v-if="slotData.scope.row.isInsder == false">否
          </el-tag>
        </template>
        <template v-slot:defaultBankNo="slotData">
          <div style="text-decoration: underline; cursor: pointer"
               @click="setCard(slotData.scope.row)">
            {{
              slotData.scope.row.defaultBankNo
                ? slotData.scope.row.defaultBankNo
                : "点击设置工资卡号"
            }}
          </div>
        </template>
        <template v-slot:time="slotData">
          {{
            slotData.scope.row.createDate &&
            slotData.scope.row.createDate.slice(0, 10)
          }}
        </template>

        <template v-slot:entryDate="slotData">
          {{
            slotData.scope.row.entryDate &&
            slotData.scope.row.entryDate.slice(0, 10)
          }}
        </template>
        <template v-slot:cname="slotData">
          <span v-if="slotData.scope.row.cname">
            {{ slotData.scope.row.cname }}
          </span>
          <span v-else
                class="userFlag"> 用户未完善资料 </span>
          {{
            slotData.scope.row.nickName
              ? "  (" + slotData.scope.row.nickName + ")"
              : ""
          }}
        </template>
        <template v-slot:operation="slotData">
          <el-button @click="editCustomerInfo(slotData.scope.row)"
                     size="small"
                     icon="el-icon-edit"
                     :loading="submitLoading"
                     v-if="verifyPermission('Update')">编辑</el-button>
        </template>
      </MyTable>
      <Pagination class="PagPosition"
                  :total="total"
                  @getNewData="getCustomerList"
                  ref="pagination" />
    </div>
    <!-- <el-dialog
      title="编辑上级"
      :visible.sync="userDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="380px"
      @close="resetUserForm"
    >
      <el-form
        ref="userForm"
        :model="userForm"
        :inline="true"
        v-enterToNext="true"
      >
        <el-form-item label="上级姓名" prop="creditCode">
          <el-select
            filterable
            v-model="userForm.parentId"
            clearable
            remote
            :loading="selectloading"
            style="width: 130%"
            placeholder="请输入员工姓名"
            :remote-method="GetUserListByKeyWord"
            @clear="clearSearchList"
          >
            <el-option
              v-for="item in searchList"
              :key="item.id"
              :label="
                item.cname +
                '(' +
                item.tel +
                ')' +
                (item.userType == 0
                  ? ''
                  : item.userType == 1
                  ? '-推荐人'
                  : '-经纪人')
              "
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small "
          type="primary"
          :loading="submitLoading"
          @click="onParentSubmit('userForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
    <el-dialog title="批量导入"
               :visible.sync="importVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="880px"
               @close="resetImport"
               center>
      <div class="file">
        <div class="title">
          <span class="num">1</span>
          <span class="tip">请下载模板并进行填写</span>
        </div>
        <div style="padding: 10px 70px">
          <el-link type="success"
                   icon="el-icon-download"
                   @click="downloadDoc">下载模板</el-link>
        </div>
      </div>
      <div class="file">
        <div class="title">
          <span class="num">2</span>
          <span class="tip">将填写好的Excel拖拽至下方进行上传</span>
        </div>

        <el-upload class="upload-demo"
                   drag
                   accept=".xls,.xlsx"
                   :http-request="uploadfile"
                   :limit="1"
                   action=""
                   :auto-upload="false"
                   ref="upload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip"
               slot="tip">
            只能上传xls/xlsx文件，且只能上传一个(重复的数据会采用最新的进行覆盖)
          </div>
        </el-upload>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="uploadServe">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入结果"
               :visible.sync="importResult"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="880px"
               center
               @close="(importResult = false), (fileVisible = false)">
      <div class="table">
        <div class="title">
          <span class="num"><i class="el-icon-info"></i></span>
          <span class="tip">以下批量处理结果 </span>
        </div>

        <div class="result">
          <div class="callback">
            你本次导入
            <span style="font-size: 20px; color: #65a2f9">{{
              totalCount
            }}</span>
            条数据，成功
            <span style="font-size: 20px; color: #4ee07f">{{
              succeedCount
            }}</span>
            条<br /><br />
            <!-- 其中在职且卡号为空
            <span style="font-size: 20px; color: #fc5531">{{
              tableData2.length
            }}</span>
            条 &nbsp;
            <el-button size="mini" type="primary">通知开卡</el-button> -->
          </div>

          <div>
            <el-table :data="tableData2"
                      border
                      style="width: 100%"
                      max-height="500px">
              <el-table-column prop="date"
                               align="center"
                               label="失败人员名单(包括重复导入)">
                <el-table-column align="center"
                                 label="姓名"
                                 prop="name">
                </el-table-column>
                <el-table-column align="center"
                                 label="性别"
                                 prop="sex">
                </el-table-column>
                <el-table-column align="center"
                                 label="身份证号"
                                 prop="identityCard">
                </el-table-column>
                <el-table-column align="center"
                                 label="手机号码"
                                 prop="tel">
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   :loading="submitLoading"
                   @click="(importResult = false), (fileVisible = false)">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量录入人员"
               :visible.sync="fileVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="440px"
               center>
      <div style="display: flex; justify-content: center">
        <el-button size="mini"
                   type="success"
                   @click="openDialog">小程序码录入</el-button>
        <el-button size="mini"
                   type="primary"
                   @click="importVisible = true"
                   style="margin-left: 15px">导入excel</el-button>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small "
                   :loading="submitLoading"
                   @click="fileVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量修改状态"
               :visible.sync="stateDialogVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               class="colleague-dialog"
               @close="resetForm()">
      <el-form ref="form"
               :model="form"
               :inline="true"
               :rules="rules"
               label-width="90px">
        <el-form-item label="状态"
                      prop="state">
          <el-select v-model="form.state"
                     clearable
                     style="width: 100%"
                     placeholder="请选择状态">
            <el-option v-for="item in statusList"
                       :key="item.Value"
                       :label="item.value"
                       :value="item.num"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间"
                      v-show="form.state == 6">
          <el-date-picker v-model="form.entryDate"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择入职时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="驻厂"
                      v-show="form.state && form.state != 1">
          <el-input v-model="form.fieldService"
                    placeholder="选择输入驻厂"></el-input>
        </el-form-item>
        <el-form-item label="企业"
                      v-show="form.state && form.state != 1">
          <el-select filterable
                     v-model="form.entryFactoryId"
                     clearable
                     style="width: 100%"
                     @change="PositionList"
                     placeholder="请选择企业"
                     ref="entryFactoryId">
            <el-option v-for="item in companyList"
                       :key="item.id"
                       :label="item.customerName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职位"
                      v-show="
            (form.state == 6 || form.state == 7 || form.state == 8) &&
            form.entryFactoryId
          ">
          <el-select filterable
                     v-model="form.entryPositionId"
                     clearable
                     style="width: 100%"
                     placeholder="请选择职位"
                     ref="entryPositionId">
            <el-option v-for="item in positionList"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="离职时间"
                      v-show="form.state == 7 || form.state == 8">
          <el-date-picker v-model="form.dimissionDate"
                          type="date"
                          value-format="yyyy-MM-dd"
                          placeholder="选择离职时间">
          </el-date-picker>
        </el-form-item>
        <!-- <el-col :span="24">
          <el-form-item label="备注" class="myitem">
            <el-input v-model="form.title" class="myInput"></el-input>
          </el-form-item>
        </el-col> -->
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="
            () => {
              resetForm();
              stateDialogVisible = false;
            }
          ">关 闭</el-button>
        <el-button size="small "
                   type="primary"
                   :loading="submitLoading"
                   @click="changeState('form')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="小程序码录入"
               :visible.sync="QRVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="400px"
               center
               @close="closeDialog">
      <div style="display: flex; justify-content: center">
        <img :src="imgPath"
             alt="" />

      </div>
    </el-dialog>
    <AddRegistration :drawerShow="addCustomerDrawerShow"
                     :title="drawerTitle"
                     type="0"
                     :operation="operation"
                     :customerInfo="customerInfo"
                     @colseDrawer="addCustomerDrawerShow = false"
                     @refreshData="
        () => {
          getCustomerList();
        }
      " />

  </div>
</template>

<script>
import AddRegistration from "./AddRegistration";
import MyTable from "@/components/Table";
import { showWorkState } from "@/utils/common.js";
import { verifyPermissionMinix, GetUnlimitedQRCodeMinix } from "@/utils/mixin";
import Search from "@/components/Search";


export default {
  components: {
    AddRegistration,
    MyTable,
    Search,
  },
  mixins: [verifyPermissionMinix, GetUnlimitedQRCodeMinix],

  data () {
    return {
      tableName: "TalentPoolTable",
      userForm: {},
      flag: true,
      form: {},
      delPara: {
        data: "",
        controller: "user",
        action: "CompanyUserListBatchDelete",
        callback: "getCustomerList",
      },
      firstId: "",
      selectloading: false,
      dialogVisible: false,
      addCardShow: false,

      totalCount: 0,
      onerow: "",
      companyList: [],
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        state: [
          {
            required: true,
            message: "请选择状态",
            trigger: ["blur", "change"],
          },
        ],
        entryDate: [
          { required: true, message: "请选择入职时间", trigger: "blur" },
        ],
        dimissionDate: [
          { required: true, message: "请选择离职时间", trigger: "blur" },
        ],
        entryFactory: [
          { required: true, message: "请选择入职企业", trigger: "blur" },
        ],
      },
      tableConfig: [
        {
          field: "createDate",
          label: "报名时间",
          slotName: "time",
          minWidth: 80,
          align: "center",
          width: 150,
          flag: true,
        },
        {
          field: "cname",
          label: "计划批次号",
          align: "center",
          slotName: "cname",
          flag: true,
          minWidth: 150,
        },
        {
          field: "sex",
          label: "计划名称",
          align: "center",
          width: 170,
          flag: true,
        },
        {
          field: "tel",
          label: "企业名称",
          align: "center",
          width: 130,
          flag: true,
        },

        {
          field: "identityCard",
          label: "职位名称",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "defaultBankName",
          label: "姓名",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "defaultBankNo",
          label: "手机号",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "permanentResidence",
          label: "身份证",
          align: "center",
          width: 180,
          flag: true,
        },


        {
          field: "state",
          label: "人员状态",
          align: "center",
          slotName: "state",
          width: 180,
          flag: true,
        },

        {
          label: "基本操作",
          slotName: "operation",
          width: 110,
          align: "center",
          flag: true,
          fixed: "right",
        },
      ],
      submitLoading: false,
      searchList: [],
      tabList: [],
      tabIndex: 0,
      addCustomerDrawerShow: false,
      registrationRecordVisible: false,
      imageManageVisible: false,
      currentRow: null,
      registrationRecordtRow: null,
      drawerTitle: "",
      total: 0,
      loading: false,
      tableData: [],
      tableData2: [],
      searchForm: {},
      positionList: [],
      row: "",
      userDialogVisible: false,
      statusList: [
        {
          value: "待处理",
          num: 1,
        },
        {
          value: "待面试",
          num: 2,
        },
        {
          value: "面试未通过",
          num: 3,
        },
        {
          value: "待入职",
          num: 4,
        },
        {
          value: "未入职",
          num: 5,
        },
        {
          value: "已入职",
          num: 6,
        },
        {
          value: "已离职",
          num: 8,
        },
        {
          value: "已离职(自离)",
          num: 7,
        },
      ],
      customerIds: [],
      customerInfo: null,
      dataFlag: true,
      importResult: false,
      stateDialogVisible: false,
      operation: "",
      imgPath: "",
      fileVisible: false,
      importVisible: false,
      QRVisible: false,
      userAutoIntId: "",
      CompanyAutoIntId: "",
      companyId: "",
      exportBtnIsDisabled: false,
      tableHeight: "",
      defeatedCount: 0,
      succeedCount: 0,
      oneId: [],
    };
  },
  computed: {
    exportBtnText: function () {
      var textArr = ["导出Excel", "请稍候..."];
      var text = this.exportBtnIsDisabled ? textArr[1] : textArr[0];
      return text;
    },
  },
  mounted () {
    this.getCompanyList();
    this.getCustomerList();
    let detail = JSON.parse(window.localStorage.getItem("userInfo"));
    let Companydetail = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    );
    this.userAutoIntId = detail.autoIntId;
    this.CompanyAutoIntId = Companydetail.autoIntId;
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  filters: {
    state (num) {
      return showWorkState(num);
    },
  },
  methods: {
    dbclick (row) {
      this.editCustomerInfo(row);

    },
    setCard (row) {
      this.onerow = row;
      this.addCardShow = true;
    },
    resetImport () {
      this.$refs.upload.clearFiles();
    },
    closeDialog () {
      this.fileVisible = false;
      // document.getElementById("qrcode").innerHTML = "";
    },
    // 打开并生成二维码
    openDialog () {
      this.$nextTick(() => {
        this.qrcode();
      });
    },
    qrcode () {

      if (!this.imgPath) {

        let sendData = {
          page: "pages/packageC/home/recordPerson",
          check_path: false,
          width: 150,
          scene: "cid=" + this.userAutoIntId + "-" + this.CompanyAutoIntId,
        };
        this.GetUnlimitedQRCode(sendData).then((res) => {
          this.imgPath = "data:image/png;base64," + res;
          this.submitLoading = false;
          this.QRVisible = true;
        });
      } else {
        this.QRVisible = true;
      }

    },

    changeState (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let sendData = {
          entryDate: this.form.entryDate,
          idList: this.oneId.length == 1 ? this.oneId : this.customerIds,
          dimissionDate: this.form.dimissionDate,
          state: this.form.state,
          entryFactory: this.$refs.entryFactoryId.selected.label,
          entryFactoryId: this.form.entryFactoryId,
          entryPosition: this.$refs.entryPositionId.selected.label,
          entryPositionId: this.form.entryPositionId,
          fieldService: this.form.fieldService,
        };
        this.$api.user.CompanyUserListBatchUpdateSata(sendData).then((res) => {
          this.submitLoading = false;
          if (res.code === 0) {
            this.getCustomerList();
            this.$message.success("保存成功");
            this.customerIds = [];
            this.form = {};
            this.stateDialogVisible = false;
          } else {

          }
          this.$refs[formName].resetFields();
        });
      });
    },
    getCompanyList () {
      let sendData = {
        loading: false,
      };
      this.$api.customer.getAllCustomerList(sendData).then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        }
      });
    },

    PositionList () {
      let sendData = {
        customerId: this.form.entryFactoryId,
      };
      this.$api.posts.PositionAllList(sendData).then((res) => {
        if (res.error === false) {
          this.positionList = res.data;
        }
      });
    },
    PositionList2 () {
      this.positionList = [];
      if (this.searchForm.entryFactoryId) {
        let sendData = {
          customerId: this.searchForm.entryFactoryId,
        };
        this.$api.posts.PositionAllList(sendData).then((res) => {
          if (res.error === false) {
            this.positionList = res.data;
          } else {

          }
        });
      }
    },
    downloadDoc () {
      // 创建一个<a></a>标签
      const a = document.createElement("a");
      a.href = "../excel/userTemplate.xls";
      a.download = "userTemplate.xls";

      // 障眼法藏起来a标签
      a.style.display = "none";
      // 将a标签追加到文档对象中
      document.body.appendChild(a);
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click();
      // 一次性的,用完就删除a标签
      a.remove();
    },
    // 把文件上传到服务器
    uploadServe () {
      this.$refs.upload.submit();
    },
    // 上传文件的方法
    uploadfile (fileObj) {
      this.submitLoading = true;
      const formData = new FormData();
      formData.append("file", fileObj.file);
      this.$api.user.ImportUserData(formData).then((res) => {
        if (res.code === 0) {
          this.importVisible = false;
          this.importResult = true;
          this.defeatedCount = res.data.defeatedCount;
          this.succeedCount = res.data.succeedCount;
          this.totalCount = res.data.totalCount;
          this.tableData2 = res.data.defeatedUserList;
          this.getCustomerList();

        }
        this.submitLoading = false;
      });
      console.log(2);
    },
    importExport () {
      this.fileVisible = true;
      // this.importVisible = true;
    },
    oneClick (row) {
      this.oneId = [];
      this.oneId.push(row.id);
      this.stateDialogVisible = true;
    },
    batchState () {
      if (this.customerIds.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }

      this.stateDialogVisible = true;
    },
    clearSearchList () {
      this.searchList = [];
    },
    GetUserListByKeyWord (e) {
      if (e != "") {
        this.selectloading = true;
        setTimeout(() => {
          this.$api.user.GetUserListByKeyWord(e).then((res) => {

            if (res.error === false) {
              this.searchList = res.data;
            }
            this.selectloading = false;
          });
        }, 300);
      }
    },
    onParentSubmit () {
      let sendData = {
        firstId: this.firstId,
        parentId: this.userForm.parentId ? this.userForm.parentId : "",
      };
      this.$api.user.UpdateParent(sendData).then((res) => {

        if (res.error === false) {
          this.$message.success("保存成功");
          this.getCustomerList();
        }
        this.userDialogVisible = false;
        this.resetUserForm();
      });
    },
    resetUserForm () {
      this.userForm = {};
      this.$refs.userForm.clearValidate();
    },
    updateParent (item) {
      this.firstId = item.id;
      this.userDialogVisible = true;
    },

    selectChange (value, field, id) {
      let sendData = {
        idList: [id.id],
        state: value,
      };
      this.$api.user.CompanyUserListBatchUpdateSata(sendData).then((res) => {
        if (res.code === 0) {
          // this.getCustomerList();
          this.$message.success("保存成功");
        }
      });
      console.log(value, field, id);
    },
    // 后台获取排序
    sortChange (column) {
      if (this.sortType == "custom") {
      }
    },
    // 列的显示与隐藏
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    getHeight (height) {
      this.tableHeight = height;
    },
    //清除资格
    disqualification (id) {
      this.$confirm("确认要清除资格吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(id);

          this.$api.user.RemoveUserQualification(id).then((res) => {

            if (res.error === false) {
              this.$message.success("清除成功");
              this.getCustomerList();
            } else {
              this.$message.error("清除失败");
            }
          });
        })
        .catch((err) => { });
    },
    //重置表单
    resetForm () {
      this.form = {};
      this.$refs.form.clearValidate();
    },
    //查看报名纪录
    pass (id) {
      var sendData = {
        userId: id,
        pageIndex: 1,
        pageSize: 10,
        keyWord: "",
      };
      this.$api.user.UserApplyPage(sendData).then((res) => {

        if (res.error === false) {
          this.registrationRecordVisible = true;
          this.registrationRecordtRow = res;
          this.registrationRecordtRow.id = id;
        }
      });
    },
    open (id) {
      var sendData = {
        userId: id,
        pageIndex: 1,
        pageSize: 20,
        keyWord: "",
      };
      this.$api.user.UserChildishPage2(sendData).then((res) => {

        if (res.error === false) {
          this.imageManageVisible = true;
          this.currentRow = res;
          this.currentRow.id = id;
        }
      });
    },
    clear () {
      console.log(0);
      this.searchForm.isCooperation = undefined;
    },
    //排序
    sortCustomer () {
      let arr = [];
      let obj = {};
      this.tableData.forEach((element) => {
        if (element.add == "1") {
          obj.id = element.id;
          obj.sort = element.sort;
          arr.push(obj);
          obj = {};
        }
      });
      this.$api.customer.sort(arr).then((res) => {
        if (res.error === false) {
          this.getCustomerList();
        }
      });
    },
    //获取数据
    getCustomerList () {
      this.loading = true;
      let Data = "";
      let sendData = {};
      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
        state: this.searchForm.state,
        entryFactoryId: this.searchForm.entryFactoryId,
        createStatrDate: this.searchForm.createStatrDate,
        entryStartDate: this.searchForm.entryStartDate,
        createEndDate: this.searchForm.createEndDate,
        entryEndDate: this.searchForm.entryEndDate,
        entryPositionId: this.searchForm.entryPositionId,
        isHaveIdentityCard: this.searchForm.isHaveIdentityCard,
        isVeteran: this.searchForm.isVeteran,
        keyWord: this.searchForm.keyWord,
      };
      this.$api.user.CompanyUserListPage(sendData).then((res) => {
        this.loading = false;
        if (!res.error) {

          this.tableData = res.data.data;
          if (res.data.data.length <= 0) {
            this.dataFlag = false;
          } else {
            this.dataFlag = true;
          }
          this.total = res.data.count;
        }
      });
    },

    // 添加客户
    addCustomer () {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增公司";
      // tableData2批量导入;
    },
    // 删除用户
    deleteCustomer (ids) {
      console.log(ids);
      // if (ids.length <= 0) {
      //   return this.$message.warning("请至少选择一条数据");
      // }
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.user.UpdateDelete(ids).then((res) => {

            if (res.error === false) {
              this.getCustomerList();
              this.$message.success("删除成功");
            }
          });
        })
        .catch(() => { });
    },
    getCustomerDetails (id) {
      return new Promise((resolve, reject) => {
        this.$api.user.CompanyUserListDetail({ id: id }).then((res) => {
          // console.log(res);
          if (res.error === false) {
            resolve(res.data);
          } else {
            reject(this.$message.error(res.msg));
          }
        });
      });
    },
    // 新增人才
    AddRegistrations () {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增报名";
    },
    // 修改人才信息
    editCustomerInfo (row) {
      // console.log(row.id);
      this.submitLoading = true;
      this.getCustomerDetails(row.id).then((res) => {
        if (res) {

          this.operation = "edit";
          this.customerInfo = res;
          this.addCustomerDrawerShow = true;
          this.submitLoading = false;
          this.drawerTitle = "编辑报名";
        }
      });
    },

    imageManage (row) {
      this.imageManageVisible = true;
      this.currentRow = row;
      console.log(row);
    },

    handleSearch () {
      let Data = "";
      let sendData = {};
      this.$refs.pagination.currentPage = 1;
      this.$refs.pagination.pageSize = 20;

      sendData = {
        pageIndex: this.$refs.pagination.currentPage,
        pageSize: this.$refs.pagination.pageSize,
      };
      Data = {
        startDate: this.searchForm.startDate,
        userType: this.searchForm.isCooperation,
        endDate: this.searchForm.endDate,
        keyWord: this.searchForm.keyWord,
        isOnjob: this.searchForm.isOnjob,
      };

      for (let i in Data) {
        if (Data[i] != undefined) {
          sendData[i] = Data[i];
        }
      }

      if (JSON.stringify(sendData) != "{}") {
        this.$api.user.UserPage(sendData).then((res) => {

          this.tableData = res.data.data;
          this.total = res.data.count;
        });
      } else {
        this.getCustomerList();
      }
    },
    selectionChange (selection) {
      this.oneId = [];
      this.customerIds = selection.map((v) => {
        return v.id;
      });
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },
  },
};
</script>
<style lang="less" >
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
</style>
<style lang="less">
.userFlag {
  color: gray;
  font-style: italic;
}
.el-table .cell {
  white-space: pre-line;
}
.chabtn {
  margin-left: 15px;
}
.btn {
  margin-left: 15px;
}
.customer-list {
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      .num {
        // color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 15px;
      }
    }

    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding: 10px 70px;
    }
  }
  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 140px);
  }
}
</style>
